import { LogOut, User } from "lucide-react";
import { useAuthStore } from "../../stores/auth.store";
import { Button } from "../ui/Button";

export function Header() {
  const { user, signOut } = useAuthStore();

  return (
    <header className="fixed top-0 right-0 left-64 z-10 h-16 border-gray-200 border-b bg-white">
      <div className="flex h-full items-center justify-between px-6">
        <div>{/* ブレッドクラムなど */}</div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 text-gray-600 text-sm">
            <User className="h-4 w-4" />
            <span>{user?.email}</span>
          </div>
          <Button className="text-gray-600" onClick={signOut} size="sm" variant="ghost">
            <LogOut className="mr-2 h-4 w-4" />
            ログアウト
          </Button>
        </div>
      </div>
    </header>
  );
}
